/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'check-mark': {
    width: 19,
    height: 14,
    viewBox: '0 0 19 14',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M18.354 1.354L6 13.707.646 8.354l.708-.708L6 12.293 17.646.646l.708.708z" _fill="currentColor"/>'
  }
})
